import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined,UserOutlined,PhoneOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Card,
    List,Checkbox,
    Popconfirm, Form, Switch, notification, Select, Modal
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";
import cookie from "react-cookies";

const {Title, Text} = Typography;
const {Content} = Layout;

const confirm = (e) => {
    window.open('http://booleango-stsn.oss-cn-beijing.aliyuncs.com/hetong.docx');
};
const DecimalStep = (id) => {

    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [modalText, setModalText] = useState('是否提交此合同进行审核，审核后合同视为生效，不可撤回，请谨慎操作。');

    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            fetch("https://pd.pokemonbye.com:8084/api/setsellcontractstatesigntime?state=3&id=" + id.id)
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload()

                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };

    return (
        <>
            <Button type="primary" size="large" onClick={showModal}>提交审核</Button>
            <Modal
                title="提交审核"
                open={open}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
            >

                <p>{modalText}</p>
            </Modal>
        </>
    );
};
const Delete = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            fetch("https://pd.pokemonbye.com:8084/api/setsellstockstate?state=0&id=" + id.id)
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload()

                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        console.log('删除后将不可恢复');
        setOpen(false);
    };
    return (
        <Popconfirm
            title="删除后将不可恢复"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Button onClick={showPopconfirm}>
                删除
            </Button>
        </Popconfirm>
    );
};
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '产品信息修改成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};

class PageBusContractEd extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const userid = cookie.load('userId');
        this.state = {
            title: "新建合同",
            county: [],
            id: id,
            userid:userid,
            list: [],
            options: [],
            menu: [],
            menus: [],
            array: {},
            data: {},
            sum: 0,
            stockname: [],
            stockvalue: [],
            client:''
        };
    }

    componentDidMount() {
        var id = this.state.id
        if(id){
        }else{

            fetch("https://pd.pokemonbye.com:8084/api/getsellstock")
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        let options = [];
                        for (let i = 0; i < array.length; i++) {
                            let l = {
                                value: array[i].stockname,
                                label: array[i].stockname,
                                price: array[i].stockprice
                            }
                            options.push(l)
                            array[i].id = i + 1
                        }
                        this.setState({
                            isLoaded: true,
                            options: options
                        });
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )


            fetch("https://pd.pokemonbye.com:8084/api/getsellclientlist")
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        var menu = [];
                        for (let i = 0; i < array.length; i++) {
                            menu.push(
                                {
                                    value: array[i].id,
                                    label: array[i].name
                                }
                            )
                        }
                        this.setState({
                            isLoaded: true,
                            menu: menu
                        });
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )

            fetch("https://pd.pokemonbye.com:8084/api/getsellclientman")
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        var menu = [];
                        for (let i = 0; i < array.length; i++) {
                            menu.push(
                                {
                                    value: array[i].id,
                                    label: array[i].name
                                }
                            )
                        }
                        this.setState({
                            isLoaded: true,
                            menus: menu
                        });
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )

            fetch("https://pd.pokemonbye.com:8084/api/getsellclausenew")
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        if(array!=null&&array.length>0){

                            this.setState({
                                isLoaded: true,
                                list: array[0]
                            })
                            this.formRef.current.setFieldsValue(array[0])
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
    }
    formRef = React.createRef();
    render() {
        const Load = (client) =>{

            fetch("https://pd.pokemonbye.com:8084/api/getsellstockprice?client=" + client)
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        let options = [];
                        for (let i = 0; i < array.length; i++) {
                            if(array[i].stockprice){

                            }
                            let l = {
                                value: array[i].stockname,
                                label: array[i].stockname,
                                price: array[i].stockprice ? array[i].stockprice : 0
                            }
                            options.push(l)
                            array[i].id = i + 1
                        }
                        this.setState({
                            isLoaded: true,
                            options: options
                        });
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
        const onClientChange = (value) => {
            console.log(value);
            var client = ''
            for (let i = 0; i < this.state.menu.length; i++) {
                if(value == this.state.menu[i].value){
                    client = this.state.menu[i].label
                }
            }
            this.setState({
                client: client
            });
            Load(value)
        };
        const onChange = (value) => {
            var list = this.state.stockname
            var list1 = this.state.stockvalue
            if(list.includes(value.target.id)){
                if(value.target.value==''){
                    for (var i = 0; i < list.length; i++) {
                        if (list[i] === value.target.id) {
                            list.splice(i, 1);
                            list1.splice(i, 1);
                        }
                    }
                }else{
                    for (var i = 0; i < list.length; i++) {
                        if (list[i] === value.target.id) {
                            list1[i] = value.target.value
                        }
                    }
                }
            }else{
                if(value.target.value!=''){
                    list.push(value.target.id)
                    list1.push(value.target.value)
                }
            }
            this.setState(
                {
                    stockname: list,
                    stockvalue: list1
                }
            )

        };
        const onClick = (value) => {
            console.log(value);
            this.setState(
                {
                    checkvalue: value
                }
            )
        };
        const onFinish = (values) => {
            var list = {};
            var listprice = []
            var sumprice = 0
            for (var i = 0; i < this.state.stockname.length; i++) {
                for (var j = 0; j < this.state.options.length; j++) {
                    if(this.state.stockname[i]==this.state.options[j].value){
                        sumprice += this.state.options[j].price * this.state.stockvalue[i]
                        listprice.push(this.state.options[j].price)
                    }
                }
            }
            list.clientid = values.client ? values.client : this.state.list.clientid;
            list.client = this.state.client ? this.state.client : this.state.list.client;
            list.stock = this.state.stockname ? this.state.stockname : '';
            list.value = this.state.stockvalue ? this.state.stockvalue : '';
            list.price = listprice ? listprice : '';
            list.sumprice = sumprice ? sumprice : 0;
            list.man = values.man ? values.man : this.state.list.man;
            list.name = values.name ? values.name : this.state.list.name;
            list.tel = values.tel ? values.tel : this.state.list.tel;
            list.clause = values.clause ? values.clause : this.state.list.clause;
            list.delivery = values.delivery ? values.delivery : this.state.list.delivery;
            list.settle = values.settle ? values.settle : this.state.list.settle;
            list.wx = this.state.userid ? this.state.userid : 1;
            list.state = 2;
            console.log(list)
            if(this.state.id){
            }else{
                function queryParse(query){
                    let queryText = "";
                    for(let key in query){
                        queryText += `${key}=${query[key]}&`;
                    }
                    return queryText.slice(0,-1);
                }

                fetch("https://pd.pokemonbye.com:8084/api/insertsellcontractstate",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            openNotification();

                            setTimeout(window.location.href="/pagebuscontracts",1000);
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }
        };

        let dom=this.state.options.map((item,index)=>{
            return <>
                    <Input addonBefore={item.label} addonAfter="吨" onChange={onChange} id={item.value}/><br/><br/>
                    </>
        })
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Form
                                    labelCol={{
                                        span: 4,
                                    }}
                                    wrapperCol={{
                                        span: 6,
                                    }}
                                    layout="horizontal"
                                    size="Large"
                                    onFinish={onFinish}
                                    ref={this.formRef}
                                    autoComplete="off"
                                >
                                    <Form.Item label="出卖方">
                                        <Input defaultValue='陕西华山建材营销有限公司' bordered={false} disabled={true}/>
                                    </Form.Item>
                                    <Form.Item label="买受方" name="client" rules={[{required: true},]}>
                                        <Select
                                            style={{
                                                width: 240,
                                            }}
                                            options={this.state.menu}
                                            onChange={onClientChange}
                                        />
                                    </Form.Item>
                                    <Form.Item label="产品规格" name="stock">
                                        {dom}
                                    </Form.Item>{/*

                                    <Form.Item label="产品规格" name="stock" rules={[{required: true},]}>
                                        <Select
                                            style={{
                                                width: 120,
                                            }}
                                            options={this.state.options}
                                        />
                                    </Form.Item>
                                    <Form.Item label="订购数量" name="value" rules={[{required: true},]}>
                                        <Input addonAfter="吨"/>
                                    </Form.Item>
                                    <Form.Item label="出厂单价" name="price" rules={[{required: true},]}>
                                        <Input addonAfter="元/吨"/>
                                    </Form.Item>
                                    <Form.Item label="合计金额">
                                        <Input disabled={true} addonAfter='￥' value={this.state.sum}/>
                                    </Form.Item>*/}
                                    <Form.Item label="出卖方经办人" name="man" rules={[{required: true},]}>
                                        <Select
                                            style={{
                                                width: 120,
                                            }}
                                            options={this.state.menus}
                                        />
                                    </Form.Item>
                                    <Form.Item label="买受方经办人" name="name" rules={[{required: true},]}>
                                        <Input prefix={<UserOutlined />}/>
                                    </Form.Item>
                                    <Form.Item label="买受方经办人电话" name="tel" rules={[{required: true},]}>
                                        <Input prefix={<PhoneOutlined />}/>
                                    </Form.Item>
                                    <Form.Item label="合同条款" name="clause">
                                        <Input.TextArea autoSize={true}/>
                                    </Form.Item>
                                    <Form.Item label="交货方式" name="delivery">
                                        <Input.TextArea autoSize={true}/>
                                    </Form.Item>
                                    <Form.Item label="结算方式" name="settle">
                                        <Input.TextArea autoSize={true}/>
                                    </Form.Item>
                                    <Form.Item
                                        wrapperCol={{
                                            offset: 4,
                                            span: 16,
                                        }}
                                    >
                                        <Button type="primary" htmlType="submit">{this.state.id?'提交修改':'提交'}</Button>
                                    </Form.Item>
                                </Form>

                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageBusContractEd;


